import { environment } from '@/environments/environment'

export default [
  { name: 'putSettingsCheckout', url: `${environment.ottawaApiUrl}/checkout-configuration/{shop_name} `, method: 'put' },
  { name: 'getShopNameCheckout', url: `${environment.ottawaApiUrl}/checkout-configuration/{company_id} `, method: 'get' }
]